import pick from 'lodash/pick';
import { createStructuredSelector } from 'reselect';
import { querySelectors } from 'store/router/routerSelectors';

export const getPropertySearchQuery = createStructuredSelector(
  pick(querySelectors, ['checkIn', 'checkOut', 'adults', 'children', 'infants', 'payWith']),
);
